<template>
  <div class="d-flex align-center column-gap-2 mb-4">
    <slot></slot>
    <v-chip size="small">
      <span class="text--x-small">
        {{ counter }}
      </span>
    </v-chip>
  </div>
</template>

<script>
export default {
  name: 'SigningChecklistSummaryListTitle',
  props: {
    counter: {
      type: Number,
      required: true,
    },
  },
}
</script>
